module.exports = __webpack_public_path__ + "static/etnews-119a392e252a4bd66992113bbdf19c8c.png";